import useSessionStorageState from 'use-session-storage-state';

const useSession = (key: string) => {
  return useSessionStorageState(key);
};

export default useSession;
